import { FolderOpen } from 'lucide-react';
import type { ModuleSpec } from '../types';

export const filesSpec: ModuleSpec = {
  id: 'files',
  icon: FolderOpen,
  i18n: {
    namespace: 'modules',
    titleKey: 'files.title',
    descriptionKey: 'files.description',
  },
  nav: {
    path: '/files',
    group: 'account',
    order: 20,
  },
  meta: {
    status: 'active',
    description: 'Manage uploaded files and storage',
  },
};
